import React from "react";
import Main from "../Structure/Main";
import Ep from "../Structure/Ep";
import Animeover from "../Structure/Animeover";
import Footer from "../components/Footer";

export default function Sololev() {
  return (
    <>
      <>
        <Main
          img="https://i.postimg.cc/Sx7Q0VYb/solo.jpg"
          name="Solo Leveling"
          s="1"
          e="12"
        />

        <Ep
          ep="S1-E1 Solo Leveling"
          s="S1-E1"
          link="https://www.mediafire.com/file/sylrmr7j2qquzcr/soloep1.mkv/file"
        />
        <Ep
          ep="S1-E2 Solo Leveling"
          s="S1-E2"
          link="https://www.mediafire.com/file/qzstm3rf37k3p7u/soloep2.mp4/file"
        />
        <Ep
          ep="S1-E3 Solo Leveling"
          s="S1-E3"
          link="https://www.mediafire.com/file/h6t49rk7cwn5l5b/soloep3.mkv/file"
        />
        <Ep
          ep="S1-E4 Solo Leveling"
          s="S1-E4"
          link="https://www.mediafire.com/file/buv626eplsqlco5/soloep4.mp4/file"
        />
        <Ep
          ep="S1-E5 Solo Leveling"
          s="S1-E5"
          link="https://www.mediafire.com/file/nofm00gouyjn3gd/Solo+Leveling+S01E05.mkv/file"
        />
        {/* <Ep ep="S1-E6 One place" s="S1-E6" />
        <Ep ep="S1-E7 One place" s="S1-E7" />
        <Ep ep="S1-E8 One place" s="S1-E8" />
        <Ep ep="S1-E9 One place" s="S1-E9" />
        <Ep ep="S1-E10 One place" s="S1-E10" />
        <Ep ep="S1-E11 One place" s="S1-E11" />
        <Ep ep="S1-E12 One place" s="S1-E12" /> */}
        <Animeover />
        <Footer />
      </>
    </>
  );
}
